import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AnalyticsTracker } from "@/lib/analytics";
import { AuthProvider } from "@/context/AuthContext";
import { LanguageProvider } from "@/context/LanguageContext";
import Layout from "@/components/Layout";
import ProtectedRoute from "@/components/ProtectedRoute";
import HomePage from "@/pages/HomePage";
import FormationsPage from "@/pages/FormationsPage";
import FormationDetailPage from "@/pages/FormationDetailPage";
import OfferPage from "@/pages/OfferPage";
import AdminPage from "@/pages/AdminPage";
import GuidesPage from "@/pages/GuidesPage";
import AboutPage from "@/pages/AboutPage";
import BlogPage from "@/pages/BlogPage";
import BlogPostPage from "@/pages/BlogPostPage";
import LoginPage from "@/pages/LoginPage";
import RegisterPage from "@/pages/RegisterPage";
import DashboardPage from "@/pages/DashboardPage";
import ModulePlayerPage from "@/pages/ModulePlayerPage";
import ExpertsPage from "@/pages/ExpertsPage";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AnalyticsTracker />
        <LanguageProvider>
        <AuthProvider>
          <Layout>
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/formations" element={<FormationsPage />} />
              <Route path="/formations/:slug" element={<FormationDetailPage />} />
              <Route path="/offre" element={<OfferPage />} />
              <Route path="/guides" element={<GuidesPage />} />
              <Route path="/offre-structures" element={<Navigate to="/offre" replace />} />
              <Route path="/offre-educateurs" element={<Navigate to="/offre" replace />} />
              <Route path="/creche-prospere" element={<Navigate to="/offre" replace />} />
              <Route path="/a-propos" element={<AboutPage />} />
              <Route path="/experts" element={<ExpertsPage />} />
              <Route path="/blog" element={<BlogPage />} />
              <Route path="/blog/:slug" element={<BlogPostPage />} />
              <Route path="/connexion" element={<LoginPage />} />
              <Route path="/inscription" element={<RegisterPage />} />
              <Route path="/espace" element={<ProtectedRoute><DashboardPage /></ProtectedRoute>} />
              <Route path="/admin" element={<ProtectedRoute><AdminPage /></ProtectedRoute>} />
              <Route path="/espace/formation/:slug" element={<ProtectedRoute><ModulePlayerPage /></ProtectedRoute>} />
            </Routes>
          </Layout>
        </AuthProvider>
        </LanguageProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
